module.exports = __webpack_public_path__ + "img/questions.675c9ba0.svg";